export async function getFileAndName(response) {
  return {
    file: await response.blob(),
    fileName: response.headers.get("Content-Disposition").replace(/(^.+={1,1})|("+)/g, ""),
  };
}
